var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocScoutUpload = function SvgDocScoutUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#doc-scout-upload_svg__clip0_6606_54941)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.97 15.262a1.001 1.001 0 0 0-1.89-.16l-.054.16a3.75 3.75 0 0 1-2.764 2.764 1 1 0 0 0 0 1.944 3.75 3.75 0 0 1 2.764 2.763 1 1 0 0 0 1.944 0 3.75 3.75 0 0 1 2.763-2.763 1 1 0 0 0 0-1.944 3.75 3.75 0 0 1-2.763-2.764",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6,
    d: "m7.001 9.001 5-5m0 0 5 5m-5-5v12M4 16.999v2a2 2 0 0 0 2 2h6.6"
  }))));
};
export default SvgDocScoutUpload;